import React from 'react';
import { GameLayout } from '@/components/layout/GameLayout';
import { CoinsGame } from '@/components/games/coins/CoinsGame';

export default function CoinsGamePage() {
  return (
    <GameLayout
      title="Cazador de Tesoros"
      description="Aprende sobre el valor del dinero mientras recolectas premios y tesoros"
    >
      <CoinsGame />
    </GameLayout>
  );
}
